import { render, staticRenderFns } from "./content-img.vue?vue&type=template&id=9de5cab0&scoped=true"
import script from "./content-img.vue?vue&type=script&lang=js"
export * from "./content-img.vue?vue&type=script&lang=js"
import style0 from "./content-img.vue?vue&type=style&index=0&id=9de5cab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de5cab0",
  null
  
)

export default component.exports